import { ACTION_TYPES } from "../types";

export const clearCreateUser = () => ({
  type: ACTION_TYPES.CREATE_USER_CLEAR,
});

export const clearApproveUser = () => ({
  type: ACTION_TYPES.APPROVE_USER_CLEAR,
});
